import { render, staticRenderFns } from "./thermal-generation-tab.vue?vue&type=template&id=df8be3f2&scoped=true"
import script from "./thermal-generation-tab.ts?vue&type=script&lang=js&external"
export * from "./thermal-generation-tab.ts?vue&type=script&lang=js&external"
import style0 from "./thermal-generation-tab.less?vue&type=style&index=0&id=df8be3f2&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8be3f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df8be3f2')) {
      api.createRecord('df8be3f2', component.options)
    } else {
      api.reload('df8be3f2', component.options)
    }
    module.hot.accept("./thermal-generation-tab.vue?vue&type=template&id=df8be3f2&scoped=true", function () {
      api.rerender('df8be3f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/operational-data/op-data-entry-details/tabs/thermal-generation-tab/thermal-generation-tab.vue"
export default component.exports